import { render } from "./CustomerBpmData.vue?vue&type=template&id=4ef3f0b7"
import script from "./CustomerBpmData.vue?vue&type=script&lang=js"
export * from "./CustomerBpmData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__